import { Component } from '@theme/component';

class ProcladShowcaseComponent extends Component {
  requiredRefs = ['bullets', 'medias'];

  #active = -1;

  #setActive(idx) {
    const { bullets, medias, chips = [] } = this.refs;
    idx = Math.max(0, Math.min(bullets.length - 1, idx));
    if (idx === this.#active) return;
    this.#active = idx;

    bullets.forEach((b, i) => {
      b.classList.toggle('is-active', i === idx);
      b.setAttribute('aria-pressed', i === idx ? 'true' : 'false');
    });
    medias.forEach((m, i) => m.classList.toggle('is-active', i === idx));
    chips.forEach((chip) => chip.classList.toggle('is-active', Number(chip.dataset.slideIndex) === idx));
  }

  selectSlide = ({ index }) => {
    this.#setActive(index);
  };

  hoverSlide = ({ index }, event) => {
    if (event.pointerType === 'touch' || !window.matchMedia('(min-width: 750px) and (hover: hover)').matches) return;
    this.#setActive(index);
  };

  connectedCallback() {
    super.connectedCallback();
    this.#setActive(0);
  }

}

if (!customElements.get('proclad-showcase-component')) {
  customElements.define('proclad-showcase-component', ProcladShowcaseComponent);
}
